import React from 'react';
import {isPRD} from '../../../../utlis/vars';
import {FmText} from '../../types/types';
import './style.scss';

const Text = ({
                children: text,
                color = 'black',
                className = '',
                weight = 'normal',
                size = 'md',
                lineHeight = 'md',
                id,
                style,
                'data-testid': dataTestId,
                inline = false,
                onClick
              }: FmText): React.ReactElement => {
  return !inline ? (
    <p
      data-testid={isPRD ? undefined : dataTestId}
      id={id}
      className={`fm-text fm-color-${color} fm-fw-${weight} fm-lh-${lineHeight} fm-fs-${size}${
        className ? ` ${className}` : ''
      }`}
      style={style}
      onClick={onClick}
    >
      {inline ? ` ${text} ` : text}
    </p>
  ) : (
    <span
      data-testid={isPRD ? undefined : dataTestId}
      id={id}
      className={`fm-text fm-color-${color} fm-fw-${weight} fm-lh-${lineHeight} fm-fs-${size}${
        className ? ` ${className}` : ''
      }`}
      style={style}
      onClick={onClick}
    >
            {` ${text} `}
        </span>
  );
};

export default Text;
